export default {
  en: {
    title: 'Dashboard',
    fetchingFailed: 'Failed to get dashboard metrics. Please retry or contact Risk Ledger support.',
    retry: 'Retry',
    yourNetwork: {
      title: 'Your network',
      viewNetwork: 'View network',
    },
    totalNetwork: {
      title: 'Total network',
    },
    totalSuppliers: {
      title: 'Shared suppliers',
    },
    totalSubEntities: {
      title: 'Sub-entities',
    },
    newestSuppliers: {
      title: 'Newest suppliers',
      viewAll: 'View all',
      emptyTitle: 'No suppliers yet',
      errorTitle: 'Failed to get the newest suppliers',
    },
  },
};
